import { useState } from 'react';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import { usePerfilCliente } from '@/shared/actions/erp/tickets-soporte-cliente/gestion-tickets-clientes.actions';
import { CustomTabPanel } from '@/shared/components/ui';

import TabInfoGeneral from '../../perfil-cliente/components/TabInfoGeneral';
import TabDatosTecnicos from '../../perfil-cliente/components/TabDatosTecnicos';
import TabHistorialTickets from '../../perfil-cliente/components/TabHistorialTickets';
import TabFinanciero from '../../perfil-cliente/components/TabFinanciero';
import TabTrazabilidad from '../../perfil-cliente/components/TabTrazabilidad';

type ModalPerfilCliente360Props = {
  open: boolean;
  onClose: () => void;
  clienteId: string | number | null;
  contratoId?: string | number | null;
  clienteNombre?: string;
};

export default function ModalPerfilCliente360({
  open,
  onClose,
  clienteId,
  contratoId,
  clienteNombre,
}: ModalPerfilCliente360Props) {
  const [tabValue, setTabValue] = useState(0);

  const { data: clienteRaw, isLoading } = usePerfilCliente(
    String(clienteId || ''),
    open && !!clienteId
  );

  const clienteData: any = (clienteRaw?.data as any)?.data || clienteRaw?.data || null;

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{ sx: { minHeight: '70vh', maxHeight: '90vh' } }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <AccountCircleIcon color="primary" />
          <Typography variant="h6" fontWeight="bold">
            {clienteNombre || 'Perfil del Cliente'} - Vista 360
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 0 }}>
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 300 }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
              >
                <Tab label="Info General" />
                <Tab label="Datos Tecnicos" />
                <Tab label="Historial Tickets" />
                <Tab label="Financiero" />
                <Tab label="Trazabilidad" />
              </Tabs>
            </Box>

            <Box sx={{ p: 2 }}>
              <CustomTabPanel value={tabValue} index={0}>
                <TabInfoGeneral clienteData={clienteData} />
              </CustomTabPanel>

              <CustomTabPanel value={tabValue} index={1}>
                <TabDatosTecnicos clienteData={clienteData} />
              </CustomTabPanel>

              <CustomTabPanel value={tabValue} index={2}>
                <TabHistorialTickets clienteId={Number(clienteId)} />
              </CustomTabPanel>

              <CustomTabPanel value={tabValue} index={3}>
                <TabFinanciero clienteData={clienteData} />
              </CustomTabPanel>

              <CustomTabPanel value={tabValue} index={4}>
                <TabTrazabilidad
                  clienteId={Number(clienteId)}
                  contratoId={Number(contratoId ?? 0)}
                />
              </CustomTabPanel>
            </Box>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
